"use client";

import { QuestsPageWrapper } from "@/components/QuestsPageWrapper";

export default function QuestsRoute() {
  return <QuestsPageWrapper />;
}